import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { CONDITION_TABS, CONDITIONS, WHATSAPP_URL } from "../data/content";

export const Conditions = () => {
  const [tab, setTab] = useState(CONDITION_TABS[0]);
  return (
    <section id="conditions" className="py-28 sm:py-36" data-testid="conditions-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Overline>Conditions Treated</Overline>
          <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-800 max-w-3xl leading-snug">
            If it concerns your breath, <span className="text-teal-700 italic">it belongs here.</span>
          </h2>
        </Reveal>
        <div className="mt-10 flex flex-wrap gap-2" role="tablist" data-testid="conditions-tabs">
          {CONDITION_TABS.map((t) => (
            <button key={t} role="tab" aria-selected={tab === t}
              data-testid={`condition-tab-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => setTab(t)}
              className={`relative px-5 py-2.5 rounded-full text-sm transition-colors duration-300 ${
                tab === t ? "text-[#FAF8F3]" : "text-stone-500 hover:text-teal-700 border border-[#E3DCCB]"
              }`}>
              {tab === t && (
                <motion.span layoutId="tab-pill" className="absolute inset-0 bg-[#0B5A4E] rounded-full"
                  transition={{ type: "spring", stiffness: 350, damping: 30 }} />
              )}
              <span className="relative z-10 font-medium">{t}</span>
            </button>
          ))}
        </div>
        <AnimatePresence mode="wait">
          <motion.div key={tab}
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {CONDITIONS[tab].map((c) => (
              <article key={c.name}
                data-testid={`condition-card-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-+$/, "")}`}
                className="p-6 rounded-2xl border border-[#E3DCCB] bg-[#FFFFFF]/50 hover:border-teal-500/40 transition-colors duration-500">
                <h3 className="font-serif-display text-lg font-semibold text-stone-800">{c.name}</h3>
                <p className="mt-2.5 text-sm text-stone-500 leading-relaxed">{c.note}</p>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-teal-700 hover:text-teal-800 transition-colors">
                  Consult for {c.name.split(" ")[0]} <ArrowUpRight size={13} />
                </a>
              </article>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};
